import React from 'react';
import CourseProvider from './CourseContext';
import ModuleProvider from './ModuleContext';
import QuestionProvider from './QuestionContext';
import UserProvider from './UserContext';
import BatchProvider from './BatchContext';
import LoginProvider from './LoginContext';
import BatchPartProvider from './BatchPartContext';
import DashProvider from './DashContext';
import CommonProvider from './CommonContext';
import TrainerProvider from './TrainerContext';
import SalesExecutiveProvider from './SalesExecutiveContext';

const Store = (props) => (
	<LoginProvider>
		<CommonProvider>
			<DashProvider>
				<UserProvider>					
				    <TrainerProvider>  
						<SalesExecutiveProvider>
						    <BatchProvider>
							    <BatchPartProvider>
								    <CourseProvider>
									    <ModuleProvider>
										    <QuestionProvider>
											   {props.children}
										    </QuestionProvider>
									    </ModuleProvider>
								    </CourseProvider>
							    </BatchPartProvider>
						    </BatchProvider>
						</SalesExecutiveProvider> 					    	
					</TrainerProvider>		
				</UserProvider>
			</DashProvider>
		</CommonProvider>
	</LoginProvider>
);

export default Store;



// WEBPACK FOOTER //
// ./contexts/provider/Store.js